<template>
  <div class="fill-width">
    <div v-if="!!label" class="text-body-2 mb-1">{{ label }}</div>

    <v-select
      v-model="value"
      :rounded="rounded"
      :outlined="outlined"
      :filled="filled"
      :solo="solo"
      :dense="dense"
      :disabled="disabled"
      :placeholder="placeholder"
      :item-text="itemText"
      :item-value="itemValue"
      :items="items"
      :rules="customRules ?? []"
      :no-data-text="noDataText"
      :color="color"
      @input="onInput"
    >
      <template v-slot:prepend-inner v-if="!hideIcon">
        <v-img src="@/assets/icons/user.svg" contain />
      </template>

      <template v-slot:prepend-inner v-else-if="appendIcon">
        <v-img contain :src="require(`@/assets/icons/${appendIcon}.svg`)" />
      </template>
    </v-select>
  </div>
</template>
<script>
export default {
  name: "custom-select",
  props: {
    label: {
      type: String,
      default: "",
    },
    itemText: {
      type: String,
      required: false,
      default: "text",
    },
    itemValue: {
      type: String,
      required: false,
      default: "value",
    },
    items: {
      type: Array,
      default: () => [],
    },
    customRules: {
      type: Array,
      default: () => [],
    },
    icon: {
      type: String,
      default: "",
    },
    noDataText: {
      type: String,
      default: "Nenhum resultado encontrado.",
    },
    placeholder: {
      type: String,
      default: "",
    },
    currentValue: null,
    hideIcon: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    appendIcon: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "",
    },
    filled: {
      type: Boolean,
      default: true,
    },
    solo: {
      type: Boolean,
      default: true,
    },
    rounded: {
      type: Boolean,
      default: true,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
  },
  beforeMount() {
    if (this.currentValue) this.value = this.currentValue;
  },
  data() {
    return {
      value: null,
    };
  },
  methods: {
    onInput(value) {
      console.log(value);
      this.$emit("input", value);
    },
  },
};
</script>
